import React, {useContext, useState} from 'react';
import {TextdomainContext} from 'react-gettext';

import MainMenu from './MainMenu';

import Employees from './Employees';
import Students from './Students';
import Collapse from '@mui/material/Collapse';
import {Alert, AlertTitle} from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import SchoolIcon from '@mui/icons-material/School';

type MainPageProps = {
  selectLang: Function;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{p: 3}}>
          {children}
        </Box>
      )}
    </div>
  );
}


const MainPage: React.FC<MainPageProps> = (props) => {
  const {selectLang} = props;

  const {gettext} = useContext(TextdomainContext);
  const url = new URL(window.location.href);
  const initTab = (/tab=students/.test(url.search)) ? 1 : 0;
  const [selectedTab, setSelectedTab] = useState(initTab);
  const hideTimeoutWarning = /session_timeout=yes/.test(url.search);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <div>
      <MainMenu selectLang={selectLang}/>
      <br/>
      <Container maxWidth="md">
        <Collapse in={hideTimeoutWarning}>
          <Alert severity="warning">
            <AlertTitle>{gettext("Sesjonen din fikk tidsavbrudd")}</AlertTitle>
            <p>{gettext("Sesjonen/innloggingen du hadde til FVO databasen koblet ned på grunn av en for lang periode med inaktivitet")}.</p>
          </Alert>
        </Collapse>
      </Container>
      <br/>
      <Container maxWidth="md">
        <Tabs value={selectedTab} onChange={handleTabChange}>
          <Tab
            label={gettext('Ansatte undervisere og administrative')}
            icon={<MedicalServicesIcon/>}
          />
          <Tab
            label={gettext('Studenter ved medisinstudiet NTNU')}
            icon={<SchoolIcon/>}
          />
        </Tabs>
        <TabPanel value={selectedTab} index={0}>
          <Employees/>
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <Students/>
        </TabPanel>
      </Container>
    </div>
  );
};

export default MainPage;

